export type FavoritePlatform = 'hcm' | 'hws';

export interface FavoriteScope {
    platform: FavoritePlatform;
    dealerId?: string;
    dealerSlug?: string;
}

export function buildFavoriteKey(scope: FavoriteScope, vehicleSlug: string): string {
    if (scope.platform === 'hcm') {
        return `hcm:${vehicleSlug}`;
    }

    if (!scope.dealerId) {
        throw new Error('HWS favorites require a dealerId');
    }

    return `hws:${scope.dealerId}:${vehicleSlug}`;
}

export function extractAdIdFromVehicleSlug(slug: string): string {
    const parts = slug.split('-');
    return parts[parts.length - 1] ?? '';
}
